<template>
  <div>
    <FloatingButtonMenu :menu="floatComponents" @select="floatMenuSelectHandler" />
    <v-layout row wrap>
      <v-flex md5 pl-2 pt-2>
        <TableCard :title="'Today\'s Data'" :headers="Headers" :items="dailytableData" />
      </v-flex>

      <v-flex md7 py-2 px-2 class="graph-column">
        <GraphCard
          :title="'Actual vs Expected Generation'"
          :graphID="1"
          :graphSeries="generationSeries"
          :xAxisData="xAxis"
          :graphYAxis="generationSeriesYAxis"
          :theme="theme"
          :tableHeaders="generationtableHeaders"
          :tableData="generationTableData"
        />
      </v-flex>

      <v-flex md5 pl-2 pt-2>
        <TableCard :title="'Present Month\'s Data'" :headers="Headers" :items="monthlytableData" />
      </v-flex>

      <v-flex md7 py-2 px-2 class="graph-column">
        <GraphCard
          :title="'Actual vs Expected Insolation'"
          :graphID="2"
          :graphSeries="insolationSeries"
          :xAxisData="xAxisInsolation"
          :graphYAxis="insolationSeriesYAxis"
          :theme="theme"
          :tableHeaders="insolationtableHeaders"
          :tableData="insolationTableData"
        />
      </v-flex>
    </v-layout>
  </div>
</template>


  <script>
import { mapGetters, mapMutations } from "vuex";
import momentTz from "moment-timezone";
import moment from "moment";
import pvsystApi from "../services/pvsyst";
import { mixin, mapGettersMixin } from "@/util/mixin/index";
import GlobalGraph from "@/components/common/GlobalGraph";
import TableCard from "../components/Pvsyst/TableCard.vue";
import GraphCard from "../components/Pvsyst/GraphCard.vue";
const FloatingButtonMenu = () =>
  import("@/components/common/FloatingButtonMenu");

export default {
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  mixins: [mixin, mapGettersMixin],
  components: {
    GlobalGraph,
    TableCard,
    GraphCard,
    FloatingButtonMenu
  },
  data() {
    return {
      generationtableHeaders: [
        { text: "Date", align: "left", value: "name", sortable: false },
        {
          text: "Actual Generation ",
          align: "center",
          value: "actual.value",
          sortable: false
        },
        {
          text: "Expected Generation",
          align: "center",
          value: "expected.value",
          sortable: false
        }
      ],
      insolationtableHeaders: [
        { text: "Date", align: "left", value: "name", sortable: false },
        {
          text: "Actual Insolation",
          align: "center",
          value: "actual.value",
          sortable: false
        },
        {
          text: "Expected Insolation",
          align: "center",
          value: "expected.value",
          sortable: false
        }
      ],
      Headers: [
        { text: "Parameters", align: "left", value: "name", sortable: false },
        {
          text: "Actual",
          align: "center",
          value: "actual.value",
          sortable: false
        },
        {
          text: "Expected",
          align: "center",
          value: "expected.value",
          sortable: false
        }
      ],
      dailytableData: [],
      monthlytableData: [],
      generationTableData: [],
      insolationTableData: [],
      generationSeries: [
        {
          name: "Expected Generation",
          type: "bar",
          large: true,
          data: []
        },
        {
          name: "Actual Generation",
          type: "bar",
          large: true,
          data: []
        }
      ],
      insolationSeries: [
        {
          name: "Expected Insolation",
          type: "bar",
          large: true,
          data: []
        },
        {
          name: "Actual Insolation",
          type: "bar",
          large: true,
          data: []
        }
      ],
      contentMapping: [
        { parameter: "energy", name: "Generation", unit: "kWh" },
        { parameter: "pr", name: "PR", unit: "%" },
        { parameter: "cuf", name: "CUF", unit: "%" },
        { parameter: "ac_yield", name: "AC Yield", unit: "kWh" },
        { parameter: "poa_insolation", name: "Insolation", unit: "W/m²" }
      ],
      xAxis: [],
      xAxisInsolation: [],
      generationSeriesYAxis: [
        {
          type: "value",
          name: "Generation (kWh)",
          position: "left",
          alignTicks: true,
          axisLine: { show: true },
          axisLabel: { formatter: "{value} kWh" }
        }
      ],
      insolationSeriesYAxis: [
        {
          type: "value",
          name: "Insolation (W/m²)",
          position: "left",
          alignTicks: true,
          axisLine: { show: true },
          axisLabel: { formatter: "{value} W/m²" }
        }
      ],
      filter: [
        {
          id: "Date",
          type: "datePicker",
          title: "Date",
        },
      ],
      activeFilter: {}
    };
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getActivePlantTimezone']),
    fullDate() {
      return this.activeFilter.Date
        ? `${this.activeFilter.Date.from}||${this.activeFilter.Date.to}`
        : null;
    },
    floatComponents() {
      return [
        {
          icon: "feed",
          path: "/pvsyst-upload",
          name: "Upload",
          component: "static"
        }
      ]
    }
  },
  mounted() {
    this.initialConfigList()

    this.fetchData();
    this.fetchDailytableData();
    this.fetchMonthlytableData();
  },
  methods: {
    initialConfigList() {
      const Obj = {}
      const cloneFilterOption = _.cloneDeep(this.filter);
      cloneFilterOption.forEach(child => {
        if (child.type === 'datePicker') {
          if (!Obj[child.id]) { Obj[child.id] = {} }
          Obj[child.id]['from'] = momentTz().tz(this.getActivePlantTimezone).startOf('month').format('YYYY-MM-DD')
          Obj[child.id]['to'] = momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
        }
      })
      this.activeFilter = Obj;
      this.$emit("filter:config", cloneFilterOption);
      this.$emit('initial:active_filter', Obj)
    },
    floatMenuSelectHandler(selection) {
      this.$router.push(selection.path);
    },
    fetchData() {
      this.fetchGenerationGraphData();
      this.fetchInsolationGraphData();
    },
    async fetchDailytableData() {
      try {
        const Date = moment().format("YYYY-MM-DD");
        const response = await pvsystApi.getDailytabledata(
          this.getSelectedPlantId,
          Date
        );
        const data = response.data;

        this.dailytableData = this.contentMapping.map(con => {
          let actualValue = "N/A";
          let expectedValue = "N/A";

          if (data.actual && data.actual[con.parameter]) {
            actualValue = data.actual[con.parameter].toFixed(2);
          }
          if (data.expected && data.expected[con.parameter]) {
            expectedValue = data.expected[con.parameter].toFixed(2);
          }
          return {
            name: con.name,
            actual: { value: actualValue },
            expected: { value: expectedValue },
            unit: con.unit
          };
        });
      } catch (error) {
        this.dailytableData = [];
      }
    },
    async fetchMonthlytableData() {
      try {
        const DateFrom = moment(this.activeFilter.Date.from, "YYYY-MM-DD");
        const DateTo = moment(this.activeFilter.Date.to, "YYYY-MM-DD");
        const response = await pvsystApi.getMonthstableData(
          this.getSelectedPlantId,
          DateFrom,
          DateTo
        );
        const data = response.data;

        this.monthlytableData = this.contentMapping.map(con => {
          let actualValue = "N/A";
          let expectedValue = "N/A";

          if (data.actual && data.actual[con.parameter]) {
            actualValue = data.actual[con.parameter].toFixed(2);
          }
          if (data.expected && data.expected[con.parameter]) {
            expectedValue = data.expected[con.parameter].toFixed(2);
          }
          return {
            name: con.name,
            actual: { value: actualValue },
            expected: { value: expectedValue },
            unit: con.unit
          };
        });
      } catch (error) {
        this.monthlytableData = [];
      }
    },
    TableViewData(expected, actual, xAxis) {
      return xAxis.map((date, index) => ({
        date,
        expected:
          expected[index] === null || expected[index] === undefined
            ? "N/A"
            : expected[index],
        actual:
          actual[index] === null || actual[index] === undefined
            ? "N/A"
            : actual[index]
      }));
    },
    async fetchGenerationGraphData() {
      try {
        const response = await pvsystApi.getEnergyGraph(
          this.getSelectedPlantId,
          this.activeFilter.Date.from,
          this.activeFilter.Date.to
        );
        const data = response.data;

        const expected = data.expected.map(el => el.energy);
        const actual = data.actual.map(el => el.energy);
        this.generationSeries = [
          { ...this.generationSeries[0], data: [...data.expected.map(el => el.energy)] },
          { ...this.generationSeries[1], data: [...data.actual.map(el => el.energy)] }
        ];
        this.xAxis = data.xAxis;
        this.generationTableData = this.TableViewData(
          expected,
          actual,
          this.xAxis
        );
      } catch (error) {
        console.error("Error fetching generation graph data:", error);
      }
    },
    async fetchInsolationGraphData() {
      try {
        const response = await pvsystApi.getInsoGraph(
          this.getSelectedPlantId,
          this.activeFilter.Date.from,
          this.activeFilter.Date.to
        );
        const data = response.data;

        const expected = data.expected.map(el => el.insolation);
        const actual = data.actual.map(el => el.insolation);
        this.insolationSeries = [
          { ...this.insolationSeries[0], data: [...data.expected.map(el => el.insolation)] },
          { ...this.insolationSeries[1], data: [...data.actual.map(el => el.insolation)] }
        ];
        this.xAxisInsolation = data.xAxis;
        this.insolationTableData = this.TableViewData(
          expected,
          actual,
          this.xAxisInsolation
        );
      } catch (error) {
        console.error("Error fetching insolation graph data:", error);
      }
    }
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    },
    fullDate(newVal, oldVal) {
      if (newVal != null && oldVal != null) {
        this.fetchData();
      }
    },
    getSelectedPlantId() {
      this.initialConfigList()
      this.fetchData();
      this.fetchDailytableData();
      this.fetchMonthlytableData();
    }
  }
};
</script>
<style scoped>
.daily-card {
  height: 384px;
}
</style>
